import { BlogChapter } from '@/entities/catalog-inside-page/BlogChapter/ui/BlogChapter.jsx'
import './ui/BlogChapter.scss'
export default BlogChapter
